import {useEffect} from 'react';

const APP_BASE_URL = process.env.REACT_APP_APP_BASE_URL;
const Home = () => {
    useEffect(() => {
        window.location.href = APP_BASE_URL;
    }, []);

    return null;
};

export default Home;
